import React from 'react';
import PropTypes from 'prop-types';

import Textarea from 'core/gd-form/form-element/textarea/textarea';
import FieldsFactory1 from "../../../../fields-factory";
import FormulaEdit_AvailableFields from "./formula-available-fields";

export default class FormulaEditPopoverForm extends React.Component {
    static propTypes = {
        form: PropTypes.object,
    }

    constructor(props) {
        super(props);

        let fieldsIds = [];

        // add all field1 system fields
        _.mapKeys(gd.const.fields.type, value=>{fieldsIds.push(value)})

        // add all custom fields
        _.map(gd.session.customFields.filterByCompany(gd.companyId).models, cf=>{fieldsIds.push(cf.id)})

        // I guess we remove this fields for all fields here
        fieldsIds = _.filter(fieldsIds, id=>id && ![
            gd.const.fields.type.SYSTEM_STATUS,
            gd.const.fields.type.PARENT_TASK_ID,
            gd.const.fields.type.CUSTOM_FIELD,
            gd.const.fields.type.PROJECT_TYPE,
            gd.const.fields.type.SUBTASKS_COUNTER,
            gd.const.fields.type.CHECK_BOX
        ].includes(id))

        this.fieldsOptions = [];

        _.map(fieldsIds, id=>{
            const field = FieldsFactory1.get(id);
            if (field && field.isFormulaCompatible()) this.fieldsOptions.push({id, field})
        });

        // Fields3 Injection
        // dont forget to update formulaField3Factory
        this.fieldsOptions.push({
            id      : 'estimateTasks',
            field   : gd.fields.project.estimateTasks
        })
        this.fieldsOptions.push({
            id      : 'estimatedCostInternal',
            field   : gd.fields.project.estimatedCostInternal
        })
        this.fieldsOptions.push({
            id      : 'estimatedCostExternal',
            field   : gd.fields.project.estimatedCostExternal
        })
    }

    optionSelect = (data) => {
        const field = data.field    // can be both field1 & field3

        // Field 3 case - but not custom fields (!)
        if (field.fieldId && !field.customField) {
            this.textarea.insert(field.variableName);
            return
        }

        // Field1 case
        this.textarea.insert('{{0}}'.f(data.field.label));
    }

    render() {
        return (
            <div className="ui5-form-formula-edit">
                <div className="ui5-form-formula-textarea">
                    <Textarea ref={r=>this.textarea = r}
                              size="big"
                              form={this.props.form}
                              name="formula"
                              noResizeControl={true}/>
                </div>
                <div className="ui5-form-formula-arrow">
                    <div className="ui5-ico-12 i5-double-arrow-left"/>
                </div>

                <FormulaEdit_AvailableFields fieldsOptions={this.fieldsOptions} optionSelect={this.optionSelect} />

            </div>
        )
    }
}
